export class LegendItem {
  constructor(_color: string, _label: string, _value: number, _showCount: boolean = true, _showLine: boolean = false) {
    this.color = _color;
    this.label = _label;
    this.value = _value;
    this.showCount = _showCount;
    this.showLine = _showLine;
  }

  label: string;
  color: string;
  value: number;
  showCount: boolean;
  showLine: boolean;
}